export const hasHebrewChar = (str) => /[\u0590-\u05FF]/.test(str)
